module.exports = __webpack_public_path__ + "static/img/b204.b7475222.png";